import React from 'react';
import { CollectionBreadcrumb } from '@/components/molecules';
import { ICollectionHeader } from './CollectionHeaderCmp';
import { Typography, WrapperExternal } from '@/components/atoms';
import styled from 'styled-components';
import { capitalize } from '@/utils/index';

const Container = styled.div`
  background-color: ${props => props.theme.collectionsHeader.backgroundColor};
  margin-bottom: 8px;
`;
const TopContent = styled.div`
  display: flex;
  flex-direction: column;
  ${props => props.theme.breakpoints.up('sm')} {
    flex-direction: row;
    align-items: flex-start;
  }
`;
const BottomContent = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 8px;
  ${props => props.theme.breakpoints.up('sm')} {
    flex-direction: row;
    align-items: center;
  }
`;

const Content = styled.div`
  margin-bottom: 8px;
  ${props => props.theme.breakpoints.up('md')} {
    margin-bottom: 16px;
  }
`;

const LeftPart = styled.div`
  ${props => props.theme.breakpoints.up('sm')} {
    width: 50%;
  }
`;

const CollectionHeader: React.FC<ICollectionHeader> = ({
  cmsCollectionTags,
  title,
}) => {
  return (
    <Container>
      <WrapperExternal>
        <Content>
          <TopContent>
            <LeftPart>
              <Typography datatype="heading_4">
                {capitalize(title || '')}
              </Typography>
            </LeftPart>
          </TopContent>
          <BottomContent>
            <LeftPart>
              <CollectionBreadcrumb collectionTags={cmsCollectionTags} />
            </LeftPart>
          </BottomContent>
        </Content>
      </WrapperExternal>
    </Container>
  );
};

export default CollectionHeader;
